module.exports = __webpack_public_path__ + "img/talent_m.5fa9dd8d.png";